function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Container, Col, Row, Media } from 'reactstrap';
import mergeStyles from '../utils/StyleMerge';
import deepmerge from 'deepmerge';

class Footer extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onClickRouterLink", (e, history, link) => {
      e.preventDefault();
      history.push(link);
    });

    _defineProperty(this, "getColumnStyle", index => {
      const {
        styles
      } = this.props;
      let columnStyle = styles.defaultColumn;

      if (styles.columns[index]) {
        if ('column' in styles.columns[index]) {
          columnStyle = deepmerge(styles.defaultColumn, styles.columns[index].column);
        }
      }

      return columnStyle;
    });

    _defineProperty(this, "getHeaderStyle", index => {
      const {
        styles
      } = this.props;
      let headerStyle = styles.defaultHeader;

      if (styles.columns[index]) {
        if ('header' in styles.columns[index]) {
          headerStyle = deepmerge(styles.defaultHeader, styles.columns[index].header);
        }
      }

      return headerStyle;
    });

    _defineProperty(this, "getLinkStyle", index => {
      const {
        styles
      } = this.props;
      let linkStyle = styles.defaultLink;

      if (styles.columns[index]) {
        if ('link' in styles.columns[index]) {
          linkStyle = deepmerge(styles.defaultLink, styles.columns[index].link);
        }
      }

      return linkStyle;
    });

    _defineProperty(this, "getImageStyle", index => {
      const {
        styles
      } = this.props;
      let imageStyle = styles.defaultImage;

      if (styles.columns[index]) {
        if ('image' in styles.columns[index]) {
          imageStyle = deepmerge(styles.defaultImage, styles.columns[index].image);
        }
      }

      return imageStyle;
    });

    _defineProperty(this, "getTextStyle", index => {
      const {
        styles
      } = this.props;
      let textStyle = styles.defaultText;

      if (styles.columns[index]) {
        if ('text' in styles.columns[index]) {
          textStyle = deepmerge(styles.defaultText, styles.columns[index].text);
        }
      }

      return textStyle;
    });

    _defineProperty(this, "renderHeader", (column, index) => {
      const headerStyle = this.getHeaderStyle(index);

      if (column.heading.length) {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            style: headerStyle
          }, column.heading)
        );
      } else {
        return null;
      }
    });

    _defineProperty(this, "renderColumn", (column, index) => {
      const {
        history,
        useRouter
      } = this.props;
      const {
        onClickRouterLink
      } = this;
      const linkStyle = this.getLinkStyle(index);
      const imageStyle = this.getImageStyle(index);
      const textStyle = this.getTextStyle(index);

      switch (column.type) {
        case 'text':
          return (
            /*#__PURE__*/
            React.createElement(React.Fragment, null, this.renderHeader(column, index), column.text.map((txt, index) =>
            /*#__PURE__*/
            React.createElement("div", {
              key: index,
              style: textStyle
            }, txt)))
          );

        case 'links':
          return (
            /*#__PURE__*/
            React.createElement(React.Fragment, null, this.renderHeader(column, index), column.links.map((link, index) => {
              return (
                /*#__PURE__*/
                React.createElement(React.Fragment, {
                  key: index
                }, link.url.length > 0 && link.type === 'phone' &&
                /*#__PURE__*/
                React.createElement("div", {
                  style: {
                    display: 'flex'
                  }
                },
                /*#__PURE__*/
                React.createElement("span", {
                  style: { ...linkStyle,
                    display: 'unset',
                    marginRight: 5
                  }
                }, link.title), " ",
                /*#__PURE__*/
                React.createElement("a", {
                  key: index,
                  style: linkStyle,
                  href: `tel:${link.url.replace('+', '').replace('.', '').replace('.', '').replace('-', '').replace('-', '')}`
                }, link.url)), link.url.length > 0 && link.type !== 'phone' &&
                /*#__PURE__*/
                React.createElement("a", {
                  key: index,
                  href: link.url,
                  onClick: useRouter && history ? e => onClickRouterLink(e, history, link.url) : null,
                  style: linkStyle
                }, link.title), link.url.length <= 0 &&
                /*#__PURE__*/
                React.createElement("div", {
                  style: linkStyle
                }, link.title))
              );
            }))
          );

        case 'image':
          return (
            /*#__PURE__*/
            React.createElement(React.Fragment, null, this.renderHeader(column, index),
            /*#__PURE__*/
            React.createElement(Media, {
              object: true,
              src: column.src,
              alt: column.title,
              style: imageStyle
            }))
          );

        default:
          return (
            /*#__PURE__*/
            React.createElement(React.Fragment, null, this.renderHeader(column, index), column.render())
          );
      }
    });
  }

  render() {
    const {
      styles,
      columns
    } = this.props;
    return (
      /*#__PURE__*/
      React.createElement(Container, {
        fluid: true,
        style: styles.container
      },
      /*#__PURE__*/
      React.createElement("div", {
        style: styles.content
      }, columns.map((column, index) => {
        const columnStyle = this.getColumnStyle(index);
        return (
          /*#__PURE__*/
          React.createElement(Col, {
            key: index,
            style: columnStyle
          }, this.renderColumn(column, index))
        );
      })))
    );
  }

}

const defaultStyles = {
  container: {
    backgroundColor: 'tan',
    padding: 0
  },
  content: {
    margin: 'auto',
    width: '100%',
    display: 'flex'
  },
  defaultColumn: {},
  defaultHeader: {},
  defaultLink: {
    fontSize: 18,
    color: 'grey'
  },
  defaultText: {
    fontSize: 18,
    color: 'grey'
  },
  defaultImage: {},
  columns: []
};
Footer.defaultProps = {
  columns: []
};
export default mergeStyles(defaultStyles)(Footer);